<template>
    <open-checkout-popup v-if="defaultPaymentMethod === 'null' && salesButtonSeen">
        <p class="timer-top-banner__title" v-html="timerTitle"></p>
    </open-checkout-popup>
    <p v-else class="timer-top-banner__title" v-html="timerTitle" @click.prevent="scrollToPaymentBlock"></p>
</template>

<script>
import { setTimerMixin } from '../../mixins/setTimerMixin';
import { fixedTopBarMixin } from '../../mixins/fixedTopBarMixin';
import { mapState } from 'vuex';

export default {
    mixins: [setTimerMixin, fixedTopBarMixin],
    props: {
        percentage: {},
        timerEndtime: {},
        topBarTimerForceEndsSoon: {},
        titles: {},
    },
    computed: {
        ...mapState(['defaultPaymentMethod', 'salesButtonSeen']),
        timerTitle: function () {
            if (this.titles) {
                return (
                    '<span data-test="timer-title">' +
                    this.formattedLongTitle +
                    '</span>'
                );
            } else {
                if (this.endsTonight) {
                    return (
                        '<span class="timer-desktop-title" data-test="timer-title">' +
                        this.$t('sales.discountEndsTonightWithNumber', { number: this.percentage }) +
                        '</span>' +
                        '<span class="timer-mobile-title">' +
                        this.$t('sales.discountEndsTonightMobileWithNumber', { number: this.percentage }) +
                        '</span>'
                    );
                } else {
                    return (
                        '<span class="timer-desktop-title" data-test="timer-title">' +
                        this.$t('sales.discountEndsSoonWithNumber', { number: this.percentage }) +
                        '</span>' +
                        '<span class="timer-mobile-title">' +
                        this.$t('sales.discountEndsSoonMobileWithNumber', { number: this.percentage }) +
                        '</span>'
                    );
                }
            }
        },
        formattedLongTitle() {
            return this.replacePlaceholderBasedOnTimer(
                this.titles.long,
                this.$t('sales.soon'),
                this.$t('sales.tonight'),
            );
        },
    },
};
</script>
